import React, { Component } from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import Home from "./home";
import {
  Navbar,
  Nav,
  NavItem,
  NavDropdown,
  MenuItem,
  Grid,
  Row,
  Col
} from "react-bootstrap";

import Turnos from "./turnos";
import $ from "jquery";
import { Checkbox, Form, Input, Select } from "formsy-react-components";
import PropTypes from "prop-types";

const axios = require("axios");

const auth = {
  isAuthenticated: localStorage.getItem("isAuthTurnos2") === "true",
  authenticate(cb) {
    this.isAuthenticated = true;
    localStorage.setItem("isAuthTurnos2", true);
    setTimeout(cb, 100);
  },
  signout(cb) {
    this.isAuthenticated = false;
    setTimeout(cb, 100);
  }
};

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props =>
      auth.isAuthenticated === true ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: "/login",
            state: { from: props.location, authenticate: props.authenticate }
          }}
        />
      )
    }
  />
);

class Login extends Component {
  state = {};
  constructor(props) {
    super(props);
    this.state = {
      user: {
        username: "",
        password: ""
      }
    };
  }
  componentWillMount() {}

  submitForm = data => {
    axios
      .post("http://190.105.227.203/turnos/login", {
        user: data
      })
      .then(response => {
        if (response.data.error == 0) {
          auth.authenticate(() => {
            this.setState(() => ({
              redirectToReferrer: true,
              error: ""
            }));
          });
        } else {
          this.setState({ error: "Usuario/Contraseña incorrectas" });
        }
      })
      .catch(error => {});
  };

  render() {
    const { from } = this.props.location.state || {
      from: { pathname: "/" }
    };

    auth.isAuthenticated = localStorage.getItem("isAuth") === "true";

    const { redirectToReferrer } = this.state;

    if (redirectToReferrer === true) {
      return <Redirect to={from} />;
    }

    return (
      <React.Fragment>
        <Navbar>
          <Navbar.Header>
            <Navbar.Brand>
              <a href="#home">Sistema Turnos</a>
            </Navbar.Brand>
          </Navbar.Header>
        </Navbar>
        <Grid>
          <Row>
            <Col md={4} mdOffset={3}>
              <div className="row" style={{ marginTop: "100px" }}>
                <Form
                  layout="vertical"
                  validateOnSubmit={PropTypes.bool.true}
                  data={this.state.user}
                  onSubmit={this.submitForm}
                  className="col s3 offset-s4"
                >
                  <Input
                    type="text"
                    className="form-control"
                    label="Usuario"
                    name="usuario"
                    value={
                      this.state.user.username === null
                        ? ""
                        : this.state.user.username
                    }
                    required
                  />
                  <Input
                    type="password"
                    className="form-control"
                    label="Password"
                    name="password"
                    value={
                      this.state.user.password === null
                        ? ""
                        : this.state.user.password
                    }
                    required
                  />
                  <h6>
                    <label>{this.state.error}</label>

                    <button
                      type="submit"
                      className="btn btn-primary btn-lg btn_reg"
                      disabled={this.state.loading}
                    >
                      Login
                    </button>
                  </h6>
                </Form>
              </div>
            </Col>
          </Row>
        </Grid>
      </React.Fragment>
    );
  }
}

class Main extends Component {
  state = {};

  componentDidMount() {
    $(".navbtn").click(function() {});

    const body = $("body");

    $(document).on({
      ajaxStart: function() {
        body.addClass("loading");
      },
      ajaxStop: function() {
        body.removeClass("loading");
      }
    });
  }
  render() {
    return (
      <main>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route path="/home" component={Home} />
          <Route path="/login" component={Login} />
          <PrivateRoute path="/turnos" component={Turnos} />
        </Switch>
      </main>
    );
  }
}

export default Main;



// WEBPACK FOOTER //
// ./src/components/main.jsx